import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.Basic
 * The DEFA Basic model.
 * @version 1.2.0
 */

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;
const api = {
	linkcom: apiHost + '/linkcom/',
	zone: '/zone',
	basic: '/basic?attrs=',
};

const Basic = ControlModel.extend( {
	
	url: function() { 
		return api.linkcom + this.get('unitId') + api.zone +
				this.get('zoneNumber') + api.basic + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
	{
		zclVersion: null,
		applicationVersion: null,
		powerSource: null,
	}),
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	parse: function( response ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			this.set('zclVersion',         response.zclVersion || null);
			this.set('applicationVersion', response.applicationVersion || null);
			this.set('powerSource',        response.powerSource || null);

			this.receivedData( response );
		}
	},

	getAttributes: function() {
		return 'zclVersion,applicationVersion,powerSource';
	},
	
} );

export default Basic;